import accounting from 'accounting'

const Money = (money: number, precision = 2) => {
    return accounting.formatMoney(money, {
        symbol: '',
        precision,
    })
}

export default Money
